<template>
	<Layout>
		<Header :bordered="false" />

		<div class="dashboard">
			<b-loading :is-full-page="false" v-model="loading"></b-loading>

			<!--
				Cards principais do dashboard:
				Empresas, Processos, Ativos, Advogados e Vidas.
			-->
			<b-carousel-list
				v-if="overview.length > 0"
				animated="slide"
				:data="overview"
				:has-drag="true"
				:items-to-show="isDesktop ? 5 : isTablet ? 4 : 2"
			>
				<template #item="overview">
					<div class="dashboard__box px-2 pt-3 pb-5">
						<h4 class="dashboard__box__value">
							{{ overview.value }}
						</h4>

						<span
							v-if="overview.type.charAt(0) == '$'"
							class="dashboard__box__type"
						>
							{{ $tc('menu.roles', [overview.type.length]) }}
						</span>

						<span v-else class="dashboard__box__type">
							{{ overview.type }}
						</span>
					</div>
				</template>
			</b-carousel-list>

			<!--
				Skeleton enquanto os cards principais ainda estão carregando.
			-->
			<span v-else class="dashboard__dashboard">
				<b-skeleton
					v-for="i in 5"
					:key="i"
					width="250"
					height="120"
					class="dashboard__box"
				></b-skeleton>
			</span>

			<!--
				Conteúdo que já existia no dashboard.

				Users:
				bloco de usuários/advogados.

				BigNumbers:
				agora mostra somente:
				- Taxa Mensal de Sinistro
				- Taxa Anual de Sinistro

				Removemos a média de vidas por empresa.
			-->
			<section class="columns is-multiline is-mobile mt-5">
				<Users />

				<article class="column is-12-mobile is-two-third-desktop">
					<BigNumbers :indicators="indicators" />
				</article>
			</section>

			<!--
				NOVA SEÇÃO:
				Gráfico de colunas + tabela de vidas por empresa.

				Essa seção fica abaixo de tudo que já existia.
			-->
			<section class="columns is-multiline is-mobile mt-5">
				<div class="column is-12">
					<LivesByCompany :lives-by-company="livesByCompany" />
				</div>
			</section>
		</div>
	</Layout>
</template>

<script>
/*
 * Layout padrão da aplicação.
 */
import Layout from '@/layouts/Default'

/*
 * Cabeçalho da página.
 */
import Header from '@/components/Header'

/*
 * Componente já existente no dashboard.
 */
import Users from '@/components/Users.vue'

/*
 * Componente dos indicadores.
 *
 * Agora ele não usa mais média de vidas por empresa.
 */
import BigNumbers from '@/components/BigNumbers.vue'

/*
 * NOVO COMPONENTE:
 * tabela + gráfico de vidas por empresa.
 */
import LivesByCompany from '@/components/LivesByCompany.vue'

/*
 * Serviço de API usado pelo projeto.
 */
import Api from '@/services/api'

/*
 * Mixin de responsividade já usado no dashboard.
 */
import { responsive } from '@/mixins/responsive'

/*
 * Import genérico já usado no projeto.
 */
import '@/mixins/generic'

export default {
	name: 'Dashboard',

	mixins: [responsive],

	components: {
		Layout,
		Header,
		Users,
		BigNumbers,
		LivesByCompany
	},

	data() {
		return {
			/*
			 * Controla o loading da página.
			 */
			loading: false,

			/*
			 * Mantido porque já existia no arquivo original.
			 */
			bordered: true,

			/*
			 * Cards principais do dashboard.
			 *
			 * Exemplo:
			 * [
			 *   { type: 'Empresas', value: 4 },
			 *   { type: 'Processos', value: 1 },
			 *   { type: 'Ativos', value: 1 },
			 *   { type: 'Advogados', value: 2 },
			 *   { type: 'Vidas', value: 4401 }
			 * ]
			 */
			overview: [],

			/*
			 * Indicadores do dashboard.
			 *
			 * A média de vidas por empresa foi removida.
			 *
			 * Agora esperamos somente:
			 * - monthly_rate
			 * - annual_rate
			 */
			indicators: {
				monthly_rate: 0,
				annual_rate: 0
			},

			/*
			 * NOVA VARIÁVEL:
			 * recebe a lista de vidas por empresa vinda do backend.
			 *
			 * O backend deve retornar:
			 *
			 * lives_by_company: [
			 *   {
			 *     company_id: 1,
			 *     company_name: 'Empresa A',
			 *     total_lives: 4401
			 *   }
			 * ]
			 */
			livesByCompany: []
		}
	},

	mounted() {
		/*
		 * Quando a página carregar, busca os dados do dashboard.
		 */
		this.getOverview()
	},

	methods: {
		/*
		 * Método mantido porque já existia no dashboard original.
		 *
		 * Ele pode estar sendo usado para algum gráfico antigo
		 * ou lógica futura. Não removi para evitar quebrar algo.
		 */
		fillChartData() {
			let labelsChart = []
			let dataChart = []

			this.overview.forEach((o, i) => {
				if (i > 0) {
					labelsChart.push(`${o.type} (${o.value})`)
					dataChart.push(o.value)
				}
			})
		},

		/*
		 * Busca os dados principais do dashboard na API.
		 */
		getOverview() {
			this.loading = true

			Api.get('dashboard/overview')
				.then(({ data }) => {
					/*
					 * Retorno esperado novo:
					 *
					 * {
					 *   overview: [],
					 *   indicators: {},
					 *   lives_by_company: []
					 * }
					 *
					 * Porém, deixei compatibilidade caso algum ambiente
					 * ainda retorne o formato antigo em array.
					 */
					this.overview = Array.isArray(data) ? data : data.overview || []

					this.indicators = Array.isArray(data)
						? this.indicators
						: data.indicators || this.indicators

					/*
					 * Aqui pegamos a nova lista de vidas por empresa.
					 *
					 * Se o backend ainda não retornar esse campo,
					 * mantemos como array vazio para não quebrar a tela.
					 */
					this.livesByCompany = Array.isArray(data)
						? []
						: data.lives_by_company || []

					this.fillChartData()
				})
				.catch((err) => {
					console.log(err)
				})
				.finally(() => {
					this.loading = false
				})
		}
	}
}
</script>